<template>
    <ChartNormal size="12" offset="0" title="Warranty Repair" chart="column" chartType="warranty-repair" :isCity="false" :withDate="true"
        :withFinancial="false" :warrantyRepair="true" />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
    name: "WarrantyRepair",
    components: {
        ChartNormal
    }
};
</script>
